module.exports = __webpack_public_path__ + "static/media/adminimage.662c3c86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/adminimage.jpg
// module id = 280
// module chunks = 0